import { Fancybox } from "@fancyapps/ui";

/**
 * Initializes Fancybox with the given images and options.
 * Handles different Fancybox global references for compatibility.
 * @param {string[]} images - Array of image URLs.
 * @param {object} options - Fancybox options.
 */
export function initializeFancybox(images, options) {
    const items = images.map((img) => ({ src: img, type: "image" }));

    if (window.Fancybox && window.Fancybox.show) {
        window.Fancybox.show(items, options);
    } else if (window.Fancybox && window.Fancybox.open) {
        window.Fancybox.open(items, options);
    } else if (Fancybox && Fancybox.show) {
        Fancybox.show(items, options);
    }
} 